import ContentTypeConstants from '../../../core/content-type-constants/content-type.constants';
import { ApiResponse, getFileRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';

const getQRCodesForOfficeAndAmount = async (amount: number, keycloak: KeycloakContext): Promise<ApiResponse<unknown> | undefined> => {
  const apiResponse = await getFileRequest(`qr-code?amount=${amount}`, ContentTypeConstants.PDF, keycloak);

  if (apiResponse.error) {
    return undefined;
  }

  return apiResponse;
};

export default getQRCodesForOfficeAndAmount;
